// hooks/useDashboardStats.js
import { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";

export const useDashboardStats = (token) => {
  const [stats, setStats] = useState({
    totalProducts: 0,
    totalOrders: 0,
    totalUsers: 0,
    dailySales: 0,
    weeklySales: 0,
    monthlySales: 0,
    topProducts: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get("/api/v1/auth/dashboard-overview");

        if (data.success) {
          const { overview } = data;
          setStats({
            totalProducts: overview.topProducts?.length || 0,
            totalOrders: overview.totalOrders || 0,
            totalUsers: overview.totalUsers || 0,
            dailySales: overview.totalSales?.daily || 0,
            weeklySales: overview.totalSales?.weekly || 0,
            monthlySales: overview.totalSales?.monthly || 0,
            topProducts: overview.topProducts || [],
          });
        }
      } catch (error) {
        console.error("Error fetching stats:", error);
        toast.error("Failed to load dashboard data");
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchStats();
    }
  }, [token]);

  return { stats, loading };
};
